<template>
<div>
    <v-carousel class="hero-section" v-if="slider.length > 0" style="height: 100% !important;" :cycle="true" :cycle-interval="5000" :show-arrows="false" hide-delimiter-background="false"> 
        <v-carousel-item v-for="sliders in slider" :key="sliders.itiId" class="hero-items">
            <div class=""
                :style="{ backgroundImage: 'url(' + $imgURL + sliders.insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '350px' }">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6" style="padding-top: 80px;">
                                <h1 style="color: #252525;font-size: 45px;font-weight: 700;margin-bottom: 6px;position: relative;">{{ $localeField(sliders, 'itiNome') }}</h1>
                            <p>{{ $localeField(sliders, 'itiReferencia') }}</p>
                            <router-link :to="sliders.itiLinkBtn1" class="primary-btn">{{ $localeField(sliders, 'itiTextoBtn1') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-carousel-item>
    </v-carousel>

    <!-- Banner Section Begin -->
    <div class="banner-section spad" v-if="bannerhome!=''">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-4" v-for="ban in bannerhome" :key="ban.itiId">
                    <div class="single-banner">
                        <img :src="$imgURL + ban.insInstitucionalImagens[0].itgUrlImagem" alt="">
                        <div class="inner-text">
                            <router-link :to="ban.itiReferencia">
                                <h4>{{ $localeField(ban, 'itiNome') }}</h4>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Banner Section End -->

    <!-- Women Banner Section Begin -->
    <section class="women-banner spad" >
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3" v-if="imagemsegmentos!=''">
                    <div class="product-large set-bg"
                    :style="{ backgroundImage: 'url(' + $imgURL + imagemsegmentos[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '350px' }">
                        <h2>{{ $localeField(imagemsegmentos[0], 'itiNome') }}</h2>
                        <router-link to="/Produtos/50/Nacionais">{{ $t('home.viewAll') }}</router-link>
                    </div>
                </div>
                <div class="col-lg-9" v-if="ProdutosNacional.length > 0">
                    <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="3" :breakpoints="{ 768: { slidesPerView: 3 }, 0: { slidesPerView: 1 } }" :autoplay="{ delay: 3000 }" class="carousel-testimony owl-carousel" style="height: 350px !important;">
                        <SwiperSlide v-for="prod4car in ProdutosNacional" :key="prod4car.proProdutos.proId" style="padding: 3px;">
                            <div class="product-item">
                                    <div class="pi-pic">
                                        <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                           <img  v-if="prod4car.proProdutos.proCampoExtra10 != '' && prod4car.proProdutos.proCampoExtra10 != null" :src="$imgURL + prod4car.proProdutos.proCampoExtra10" alt="" style="height: 175px;">
                                        </router-link>
                                        <div class="sale" v-if="prod4car.proProdutos.proEtiqueta != '' && prod4car.proProdutos.proEtiqueta != null"  
                                        :style="{
                                                color: prod4car.proProdutos.proEtiquetaCorFonte ? `${prod4car.proProdutos.proEtiquetaCorFonte} !important` : '#FFFFFF !important', 
                                                backgroundColor: prod4car.proProdutos.proEtiquetaCorFundo ? `${prod4car.proProdutos.proEtiquetaCorFundo} !important` : '#76BC42 !important'
                                            }"
                                        >{{ $localeField(prod4car.proProdutos, 'proEtiqueta') }}</div>
                                        <ul>
                                            <li class="quick-view">
                                                <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">{{ $t('home.moreDetails') }}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="pi-text">
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proReferencia') }}</div>
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proCampoExtra2') }}</div>
                                            <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                                <h5>{{ $localeField(prod4car.proProdutos, 'proNomeProduto') }}</h5>
                                            </router-link>
                                        <div class="product-price" v-if="prod4car.proProdutos.proValorPor > 0">
                                            {{ $t('home.fromPrice') }} R$ {{ formatarValor(prod4car.proProdutos.proValorPor) }}
                                        </div>
                                        <div class="product-price" v-else>
                                            {{ $t('home.consultPrice') }}
                                        </div>
                                    </div>
                                </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    </section>
    <!-- Women Banner Section End -->

    <!-- Deal Of The Week Section Begin-->
    <section class="deal-of-week set-bg spad" v-if="chamadadestaque!='' && timeLeft.days > 0"
    :style="{ backgroundImage: 'url(' + $imgURL + chamadadestaque[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '600px' }">
        <div class="container">
            <div class="col-lg-6 text-center">
                <div class="section-title">
                    <h2>{{ $localeField(chamadadestaque[0], 'itiNome') }}</h2>
                    <p v-html="$localeHtml(chamadadestaque[0], 'itiResumo1')"></p>
                    <div class="product-price">
                        {{ $localeField(chamadadestaque[0], 'itiReferencia') }}
                        <span>{{ $localeField(chamadadestaque[0], 'itiCampoExtra1') }}</span>
                    </div>
                </div>
                <div class="countdown-timer" id="countdown">
                    <div class="cd-item">
                        <span>{{ timeLeft.days }}</span>
                        <p>{{ $t('countdown.days') }}</p>
                    </div>
                    <div class="cd-item">
                        <span>{{ timeLeft.hours }}</span>
                        <p>{{ $t('countdown.hours') }}</p>
                    </div>
                    <div class="cd-item">
                        <span>{{ timeLeft.minutes }}</span>
                        <p>{{ $t('countdown.minutes') }}</p>
                    </div>
                    <div class="cd-item">
                        <span>{{ timeLeft.seconds }}</span>
                        <p>{{ $t('countdown.seconds') }}</p>
                    </div>
                </div>
                  <a v-if="chamadadestaque[0].itiCampoExtra3!=''" :href="chamadadestaque[0].itiCampoExtra3"  target="_blank"
                class="primary-btn">
                 {{ $localeField(chamadadestaque[0], 'itiCampoExtra2') }}
                </a>
            </div>
        </div>
    </section>
    <!-- Deal Of The Week Section End -->

    <!-- Man Banner Section Begin -->
    <section class="man-banner spad">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-9" v-if="ProdutosInternacional.length > 0">
                    <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="3" :breakpoints="{ 768: { slidesPerView: 3 }, 0: { slidesPerView: 1 } }" :autoplay="{ delay: 3000 }" class="carousel-testimony owl-carousel" style="height: 350px !important;">
                        <SwiperSlide v-for="prod4car in ProdutosInternacional" :key="prod4car.proProdutos.proId" style="padding: 3px;">
                            <div class="product-item">
                                    <div class="pi-pic">
                                        <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                           <img  v-if="prod4car.proProdutos.proCampoExtra10 != '' && prod4car.proProdutos.proCampoExtra10 != null" :src="$imgURL + prod4car.proProdutos.proCampoExtra10" alt="" style="height: 175px;">
                                        </router-link>
                                        <div class="sale"  v-if="prod4car.proProdutos.proEtiqueta != '' && prod4car.proProdutos.proEtiqueta != null" 
                                        :style="{
                                            color: prod4car.proProdutos.proEtiquetaCorFonte ? `${prod4car.proProdutos.proEtiquetaCorFonte} !important` : '#FFFFFF !important', 
                                            backgroundColor: prod4car.proProdutos.proEtiquetaCorFundo ? `${prod4car.proProdutos.proEtiquetaCorFundo} !important` : '#76BC42 !important'
                                        }"
                                        >{{ $localeField(prod4car.proProdutos, 'proEtiqueta') }}</div>
                                        <ul>
                                            <li class="quick-view">
                                                <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">{{ $t('home.moreDetails') }}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="pi-text">
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proReferencia') }}</div>
                                        <div class="catagory-name">{{ $localeField(prod4car.proProdutos, 'proCampoExtra2') }}</div>
                                            <router-link :to="AjustaUrl('/produtodetalhe/' + prod4car.proProdutos.proId, prod4car.proProdutos.proNomeProduto)">
                                                <h5>{{ $localeField(prod4car.proProdutos, 'proNomeProduto') }}</h5>
                                            </router-link>
                                        <div class="product-price" v-if="prod4car.proProdutos.proValorPor > 0">
                                            {{ $t('home.fromPrice') }} R$ {{ formatarValor(prod4car.proProdutos.proValorPor) }}
                                        </div>
                                        <div class="product-price" v-else>
                                            {{ $t('home.consultPrice') }}
                                        </div>
                                    </div>
                                </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div class="col-lg-3" v-if="imagemsegmentos!=''">
                    <div class="product-large set-bg m-large"
                    :style="{ backgroundImage: 'url(' + $imgURL + imagemsegmentos[1].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '350px' }">
                        <h2>{{ $localeField(imagemsegmentos[1], 'itiNome') }}</h2>
                        <router-link to="/Produtos/51/Internacionais">{{ $t('home.viewAll') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Man Banner Section End -->

    <!-- Latest Blog Section Begin -->
    <section class="">
        <div class="container">
            <div class="benefit-items mb-4" v-if="itenshome!=''">
                <div class="row">
                    <div class="col-lg-4" v-for="itensH in itenshome" :key="itensH.itiId">
                        <div class="single-benefit">
                            <div class="sb-icon">
                                <img :src="$imgURL + itensH.insInstitucionalImagens[0].itgUrlImagem" alt="">
                            </div>
                            <div class="sb-text">
                                <h4>{{ $localeField(itensH, 'itiNome') }}</h4><br>
                                <p v-html="$localeHtml(itensH, 'itiResumo1')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="padding-top: 60px;" v-if="blog!=''">
                <div class="col-lg-12">
                    <div class="section-title">
                        <h2>{{ $t('home.blogSection') }}</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-sm-6" v-for="bl2 in blog.slice(0,3)" :key="bl2.itiId">
                    <div class="blog-item">
                        <div class="bi-pic">
                            <router-link :to="'/BlogDetalhe/' + bl2.itiId + '/' + formataLink(bl2.itiNome)" class="rb-item">
                            <img v-if="bl2.insInstitucionalImagens!=''" :src="$imgURL + bl2.insInstitucionalImagens[0].itgUrlImagem" alt="" class="blog-img">
                            </router-link>
                        </div>
                        <div class="bi-text">
                            <router-link :to="'/BlogDetalhe/' + bl2.itiId + '/' + formataLink(bl2.itiNome)" class="rb-item">
                                <h4>{{ $localeField(bl2, 'itiNome') }}</h4>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <!-- Latest Blog Section End -->
   <CallActionPage></CallActionPage>
</div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useHead } from '@vueuse/head';
import { Swiper, SwiperSlide } from 'swiper/vue';
import Loader from '@/components/PageLoader.vue'
import CallActionPage from '@/components/PageCallAction.vue'

export default {
  name: 'HomeView',
  components: {
    Swiper,
    SwiperSlide,
    Loader,
    CallActionPage
  },
 data: () => ({
    slider:[],
    bannerhome:[],
    imagemsegmentos:[],
    ProdutosGeral:[],
    ProdutosNacional:[],
    ProdutosInternacional:[],
    chamadadestaque:[],
    targetDate: null,
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      intervalId: null,
      contato:[],
      itenshome:[],
      blog:[],
  }),
  methods: {
    formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
    carregaMetas() {
			useHead({
				title: 'Home - Sub4 Turismo'
			})
		},
    AjustaUrl(value, nome) {
            let urlFriendlyNomeProduto = nome
                .normalize("NFD") // Normaliza para decompor os caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Remove os caracteres acentuados
                .replace(/[^\w\s-]/g, "") // Remove caracteres especiais
                .replace(/\s+/g, "-") // Substitui espaços em branco por hífens
                .toLowerCase(); // Converte para minúsculas

            return `${value}/${urlFriendlyNomeProduto}`;
        },
        MontaUrl(nomeSegmento, psgId) {
            this.$router.push({
                name: 'Produtos',
                params: {
                    idSegmentoProduto: psgId,
                    nomeSegmento: nomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', ''),
                },
                replace: true,
            });
        },
         startCountdown() {
            if (!this.targetDate) return; // Garante que a contagem só comece se a data estiver definida

            this.intervalId = setInterval(() => {
                const now = new Date().getTime();
                const distance = this.targetDate - now;

                if (distance < 0) {
                clearInterval(this.intervalId);
                this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
                } else {
                this.timeLeft = {
                    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000),
                };
                }
            }, 1000);
            },
            formataLink(value){
      return value.replaceAll('/','').replaceAll(' ','-').replaceAll('.','');
    },
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  created() {
    window.scrollTo(0, 0);
   this.carregaMetas();

   
   axios.get('/Process/InsInstitucional/institucional/34/slider')
      .then(response => {
        this.slider = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
       // console.log('this.slider')
        //console.log(this.slider)
      })
      .catch(error => {
        console.error(error);
      });

      axios.get('/Process/InsInstitucional/institucional/35/bannerhome')
      .then(response => {
        this.bannerhome = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
       // console.log('this.bannerhome')
       // console.log(this.bannerhome)
      })
      .catch(error => {
        console.error(error);
      });

      axios.get('/Process/InsInstitucional/institucional/36/imagemsegmentos')
      .then(response => {
        this.imagemsegmentos = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
       // console.log('this.imagemsegmentos')
        //console.log(this.imagemsegmentos)
      })
      .catch(error => {
        console.error(error);
      });

      axios.get('/Process/ProProdutosSegmentos/GetAllBySite')
                    .then(response => {
                        //console.log(response.data)
                        this.ProdutosGeral = response.data;
                        this.ProdutosGeral = this.ProdutosGeral.sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });
                        console.log('this.ProdutosGeral')
                        console.log(this.ProdutosGeral)
                        this.ProdutosNacional = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proProdutos.proDestaque && x.proSegmentos.psgId == 50).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });

                       this.ProdutosInternacional = this.ProdutosGeral.filter(x=> x.proProdutos.proVisivel && x.proProdutos.proDestaque && x.proSegmentos.psgId == 51).sort((a, b) => {
                                                                                const valorA = parseInt(a.proProdutos.proOrdem) || 0;
                                                                                const valorB = parseInt(b.proProdutos.proOrdem) || 0;
                                                                                return valorA - valorB;
                                                                            });

                    })
                    .catch(error => {
                        console.error(error);
                    });

                   
                    axios.get('/Process/InsInstitucional/institucional/37/chamadadestaque')
                    .then(response => {
                        this.chamadadestaque = response.data;
                        const originalDate = this.chamadadestaque[0].itiData1;
                       const dateWithTime = originalDate.replace('T00:00:00', 'T23:59:59');
                        this.targetDate = new Date(dateWithTime).getTime();
                        this.startCountdown();
                     //console.log('this.chamadadestaque')
                     //console.log(this.chamadadestaque)
                    })
                    .catch(error => {
                        console.error(error);
                    });
                    
                    axios.get('/Process/InsInstitucional/institucional/16/contato')
                    .then(response => {
                        this.contato = response.data;
                    })
                    .catch(error => {
                        console.error(error);
                    });

                    
                    axios.get('/Process/InsInstitucional/institucional/38/itenshome')
                    .then(response => {
                        this.itenshome = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
                     //console.log('this.itenshome')
                     //console.log(this.itenshome)
                    })
                    .catch(error => {
                        console.error(error);
                    });

                    axios.get('/Process/InsInstitucional/institucional/42/blog')
                    .then(response => {
                        this.blog = response.data.filter(x=> x.itiVisivel).sort((a, b) => new Date(b.itiData1) - new Date(a.itiData1));
                    })
                    .catch(error => {
                        console.error(error);
                    });

       
  }
}
</script>

<style>

.blog-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px; /* opcional para cantos arredondados */
}

.v-carousel .v-carousel__controls {
    display: none;
}

   .das {
            display: block !important;
        }

    .slider-text h2 p{
      font-size: 60px;
      color:#081624;
      padding:10px;
      display: inline-block;
      background: #99CC33;
      line-height: 1;
    }

    .swiper, swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden; 
    height: 400px !important;
    list-style: none;
    padding: 0;
    z-index: 1;
    display: block;
}

.swiper-pagination-bullet-active {
    opacity: var(--swiper-pagination-bullet-opacity, 1);
    background: #212529 !important;
}

.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: var(--swiper-pagination-bottom, -5px) !important;
    top: var(--swiper-pagination-top, auto);
    left: 0;
    width: 100%;
}

.swiper-button-prev, .swiper-button-next{
    color:#212529 !important;
}
@media (max-width:767px) {

    .swiper, swiper-container {
        overflow: auto !important; 
         height: 500px !important; 
    }

    .product-price {
    display: flex;
    align-items: center;
    flex-flow: wrap;
    font-weight: 400;
    font-size: 20px;
    line-height: 1.25;
    color: #c96;
    margin-bottom: 13px;
}
}

.swiper, swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden !important;
    list-style: none;
    padding: 0;
    z-index: 1;
    display: block;
}


</style>
